// [ai] The diag beacon's transport (core/diag.ts packs the payload): one keepalive POST per tick to /api/diag?d=<tag>; the answer
// carries `want` (selectors to measure next) and `nav` (a navigation the device tool asked for). Only under ?diag=<tag>.
import { postJson } from "./http";

export type DiagAnswer = { want?: string[]; nav?: string };
export const postDiag = (tag: string, payload: unknown) => postJson<DiagAnswer>(`/api/diag?d=${encodeURIComponent(tag)}`, payload, undefined, { keepalive: true });
